module.exports = __webpack_public_path__ + "static/media/affirmations-vedio.0b8ea4f1.png";